import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { LicitacaoAudesp } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LicitacaoAudespService } from '../../service/licitacao-audesp.service';

@Component({
  selector: 'lib-licitacao-audesp-execucao-list',
  templateUrl: './licitacao-audesp-execucao-list.component.html'
})
export class LicitacaoAudespExecucaoListComponent implements OnChanges, OnDestroy {

  @Input() public licitacao: number;
  @Input() public registroPreco: number;
  @Input() public ajuste: number;
  public listaExecucao: LicitacaoAudesp[];

  protected unsubscribe: Subject<void> = new Subject();

  constructor(private audespService: LicitacaoAudespService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.ajuste) {
      this.audespService.filtrar(0, 0, { parente_id: this.ajuste, tipo: 'EXECUCAO' }).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.listaExecucao = res?.content ? res.content : [];
        })
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
